import React, { Component } from 'react';
import axios from 'axios';
import { IMaskInput } from 'react-imask';

class OffcanvasForm extends Component {
  static defaultProps = {
    show: false,
    backdrop: true,
    keyboard: true,
    productName: '', // Название товара (передается извне)
    formTitle: 'Заявка', // Заголовок формы по умолчанию
    successMessage: 'Сообщение отправлено, наш менеджер свяжется с вами в ближайшее время.',
    errorMessage: 'Произошла ошибка при отправке. Пожалуйста, попробуйте позже.'
  };

  state = {
    formData: {
      productName: this.props.productName || '',
      quantity: '',
      companyName: '',
      contactPerson: '',
      phone: '',
      email: '',
      comment: '',
      agreement: true
    },
    errors: {},
    isSending: false,
    notification: {
      show: false,
      type: 'success', // 'success' или 'error'
      message: ''
    }
  };

  componentDidMount() {
    if (this.props.show) {
      this.handleBodyScrollLock(true);
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.show !== prevProps.show) {
      this.handleBodyScrollLock(this.props.show);
      
      // Обновляем productName если он изменился извне
      if (this.props.productName !== prevProps.productName) {
        this.setState(prevState => ({
          formData: {
            ...prevState.formData,
            productName: this.props.productName || ''
          }
        }));
      }
      
      // Сбрасываем форму при открытии
      if (this.props.show && !prevProps.show) {
        this.setState({
          formData: {
            productName: this.props.productName || '',
            quantity: '',
            companyName: '',
            contactPerson: '',
            phone: '',
            email: '',
            comment: '',
            agreement: true
          },
          errors: {},
          notification: {
            show: false,
            type: 'success',
            message: ''
          }
        });
      }
    }
  }

  componentWillUnmount() {
    if (this.props.show) {
      this.handleBodyScrollLock(false);
    }
    
    // Очищаем таймаут если он есть
    if (this.notificationTimeout) {
      clearTimeout(this.notificationTimeout);
    }
  }

  handleBodyScrollLock = (lock) => {
    if (lock) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
  };

  handleBackdropClick = (e) => {
    if (e.target === e.currentTarget && this.props.backdrop) {
      this.props.hide();
    }
  };

  handleKeyDown = (e) => {
    if (this.props.keyboard && e.key === 'Escape' && this.props.show) {
      this.props.hide();
    }
  };

  handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    this.setState(prevState => ({
      formData: {
        ...prevState.formData,
        [name]: type === 'checkbox' ? checked : value
      },
      errors: {
        ...prevState.errors,
        [name]: '' // очищаем ошибку при изменении поля
      }
    }));
  };

  // Обработчик для маски телефона
  handlePhoneChange = (value) => {
    this.setState(prevState => ({
      formData: {
        ...prevState.formData,
        phone: value
      },
      errors: {
        ...prevState.errors,
        phone: ''
      }
    }));
  };

  // Показать уведомление об успехе
  showSuccessNotification = (message) => {
    this.setState({
      notification: {
        show: true,
        type: 'success',
        message: message || this.props.successMessage
      }
    });

    // Автоматически скрываем уведомление через 5 секунд
    this.notificationTimeout = setTimeout(() => {
      this.hideNotification();
    }, 5000);
  };

  // Показать уведомление об ошибке
  showErrorNotification = (message) => {
    this.setState({
      notification: {
        show: true,
        type: 'error',
        message: message || this.props.errorMessage
      }
    });

    // Автоматически скрываем уведомление через 5 секунд
    this.notificationTimeout = setTimeout(() => {
      this.hideNotification();
    }, 5000);
  };

  // Скрыть уведомление
  hideNotification = () => {
    this.setState({
      notification: {
        ...this.state.notification,
        show: false
      }
    });
  };

  validateForm = () => {
    const { formData } = this.state;
    const errors = {};

    if (!formData.contactPerson.trim()) {
      errors.contactPerson = 'Контактное лицо обязательно';
    }

    // productName — обязательное поле
    if (!formData.productName.trim()) {
      errors.productName = 'Укажите продукт';
    }

    // Телефон — проверка, что это номер телефона
    if (!formData.phone.trim()) {
      errors.phone = 'Телефон обязателен';
    } else {
      const phoneDigits = formData.phone.replace(/\D/g, '');
      if (phoneDigits.length < 11) {
        errors.phone = 'Введите полный номер телефона';
      }
    }

    // Email — обязательное поле + проверка формата
    if (!formData.email.trim()) {
      errors.email = 'E-mail обязателен';
    } else {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(formData.email.trim())) {
        errors.email = 'Введите корректный E-mail';
      }
    }

    if (!formData.agreement) {
      errors.agreement = 'Необходимо согласие на обработку данных';
    }

    return errors;
  };

  handleSubmit = (e) => {
    e.preventDefault();
    
    const errors = this.validateForm();
    if (Object.keys(errors).length > 0) {
      this.setState({ errors });
      return;
    }

    this.setState({ isSending: true });

    const { formData } = this.state;
    const { formTitle } = this.props;

    // Формируем данные для отправки
    const jsonData = {

    };

    // Удаляем пустые поля из JSON
    Object.keys(jsonData).forEach(key => {
      if (!jsonData[key]) delete jsonData[key];
    });

    axios.post(`${process.env.REACT_APP_API_URL || ''}`, {
      'content_type': 'application/json',
      'action': 'feedback_form',
      'form': formTitle,
      'name': formData.contactPerson,
      'productName': formData.productName,
      'quantity': formData.quantity,
      'companyName': formData.companyName,
      'phone': formData.phone,
      'email': formData.email,
      'comment': formData.comment
    }, {
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Request-Source': 'Node.js'
      }
    }).then((response) => {
      if (response.data.result) {
        // Показываем уведомление об успехе
        this.showSuccessNotification();
        
        // Закрываем форму
        this.props.hide();

        // Редирект на страницу благодарности через 3 секунды
        setTimeout(() => {
          if (typeof window !== 'undefined') {
            window.location.href = '/thanks';
          }
        }, 1500);
      } else {
        // Сервер вернул ошибку валидации
        this.showErrorNotification(response.data.error || this.props.errorMessage);
      }
    }).catch(error => {
      console.error('Error sending form:', error);
      // Показываем уведомление об ошибке
      this.showErrorNotification();
    }).finally(() => {
      this.setState({ isSending: false });
    });
  };

  render() {
    const { show, formTitle, backdrop = true } = this.props;
    const { formData, errors, isSending, notification } = this.state;

    return (
      <>
        {/* Backdrop */}
        {backdrop && (
          <div
            className={`
              fixed inset-0 bg-black/50 backdrop-blur-[4.6px] z-40 
              transition-opacity duration-300 ease-in-out
              ${show ? 'opacity-100' : 'opacity-0 pointer-events-none'}
            `}
            onClick={this.handleBackdropClick}
            onKeyDown={this.handleKeyDown}
            role="presentation"
          />
        )}

        {/* Уведомление */}
        {notification.show && (
          <div
            className={`
              fixed top-5 right-5 z-[60] max-w-[450px] p-4 rounded-lg shadow-lg
              transition-all duration-300 ease-in-out
              ${notification.type === 'success' ? 'bg-green-50 border border-green-200' : 'bg-red-50 border border-red-200'}
            `}
          >
            <div className="flex items-start gap-3">
              {/* Иконка */}
              <div className="flex-shrink-0">
                {notification.type === 'success' ? (
                  <svg className="w-5 h-5 text-green-500" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                  </svg>
                ) : (
                  <svg className="w-5 h-5 text-red-500" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                  </svg>
                )}
              </div>
              
              {/* Текст */}
              <div className="flex-1">
                <p className={`text-sm ${notification.type === 'success' ? 'text-green-800' : 'text-red-800'}`}>
                  {notification.message}
                </p>
              </div>
              
              {/* Кнопка закрытия */}
              <button
                onClick={this.hideNotification}
                className="flex-shrink-0 text-gray-400 hover:text-gray-600"
              >
                <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
                </svg>
              </button>
            </div>
          </div>
        )}

        {/* Offcanvas - справа */}
        <div
          className={`
            fixed right-0 top-0 h-full w-full max-w-[500px] leading-none
            bg-white shadow-xl z-50 
            transition-transform duration-300 ease-in-out
            flex flex-col md:rounded-l-[25px] overflow-hidden
            ${show ? 'translate-x-0' : 'translate-x-full'}
          `}
          role="dialog"
          aria-modal="true"
          onKeyDown={this.handleKeyDown}
        >
          {/* Фиксированная шапка */}
          <div className="flex-shrink-0 px-[20px] py-[15px] border-b border-gray-100">
            <div className="flex items-center justify-between">
              <div className='text-[22px] text-black font-semibold'>{formTitle}</div>
              <button
                type="button"
                className="border-0 bg-[#F6F6F6] w-[40px] h-[40px] rounded-full flex items-center justify-center hover:bg-gray-200 transition-colors"
                onClick={this.props.hide}
                aria-label="Закрыть"
              >
                <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M0.5 0.5L10.5 10.5" stroke="black" strokeLinecap="round"/>
                  <path d="M10.5 0.5L0.5 10.5" stroke="black" strokeLinecap="round"/>
                </svg>
              </button>
            </div>
          </div>

          {/* Прокручиваемая форма */}
          <div className="flex-1 overflow-y-auto px-[20px] py-[20px]">
            <form onSubmit={this.handleSubmit} className="space-y-[15px]">
              {/* Название товара (обязательное) */}
              <div>
                <label className="block text-[14px] text-black/60 mb-[5px]">
                  {this.props.productName ? 'Название товара' : 'Какой продукт вас интересует'} <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  name="productName"
                  value={formData.productName}
                  onChange={this.handleInputChange}
                  placeholder={!this.props.productName ? 'Какой продукт вас интересует' : ''}
                  className={`w-full h-[45px] px-[15px] border rounded-[10px] text-[14px] focus:outline-none focus:border-[#032E41] ${
                    errors.productName ? 'border-red-500' : 'border-gray-200'
                  }`}
                  readOnly={!!(this.props.productName && this.props.productName.trim())} // Только для чтения если передан непустой productName извне
                />
                {errors.productName && (
                  <p className="text-red-500 text-[12px] mt-[5px]">{errors.productName}</p>
                )}
              </div>

              {/* Количество (необязательное) */}
              <div>
                <label className="block text-[14px] text-black/60 mb-[5px]">Количество</label>
                <input
                  type="text"
                  name="quantity"
                  value={formData.quantity}
                  onChange={this.handleInputChange}
                  className="w-full h-[45px] px-[15px] border border-gray-200 rounded-[10px] text-[14px] focus:outline-none focus:border-[#032E41]"
                />
              </div>

              {/* Название компании (необязательное) */}
              <div>
                <label className="block text-[14px] text-black/60 mb-[5px]">Название компании</label>
                <input
                  type="text"
                  name="companyName"
                  value={formData.companyName}
                  onChange={this.handleInputChange}
                  className="w-full h-[45px] px-[15px] border border-gray-200 rounded-[10px] text-[14px] focus:outline-none focus:border-[#032E41]"
                />
              </div>

              {/* Контактное лицо (обязательное) */}
              <div>
                <label className="block text-[14px] text-black/60 mb-[5px]">
                  Контактное лицо <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  name="contactPerson"
                  value={formData.contactPerson}
                  onChange={this.handleInputChange}
                  className={`w-full h-[45px] px-[15px] border rounded-[10px] text-[14px] focus:outline-none focus:border-[#032E41] ${
                    errors.contactPerson ? 'border-red-500' : 'border-gray-200'
                  }`}
                />
                {errors.contactPerson && (
                  <p className="text-red-500 text-[12px] mt-[5px]">{errors.contactPerson}</p>
                )}
              </div>

              {/* Телефон с маской (обязательное) */}
              <div>
                <label className="block text-[14px] text-black/60 mb-[5px]">
                  Телефон <span className="text-red-500">*</span>
                </label>
                <IMaskInput
                  mask="+7 (000) 000-00-00"
                  value={formData.phone}
                  onAccept={this.handlePhoneChange}
                  className={`w-full h-[45px] px-[15px] border rounded-[10px] text-[14px] focus:outline-none focus:border-[#032E41] ${
                    errors.phone ? 'border-red-500' : 'border-gray-200'
                  }`}
                  lazy={true} // Показывает маску сразу
                />
                {errors.phone && (
                  <p className="text-red-500 text-[12px] mt-[5px]">{errors.phone}</p>
                )}
              </div>

              {/* E-mail (обязательное) */}
              <div>
                <label className="block text-[14px] text-black/60 mb-[5px]">
                  E-mail <span className="text-red-500">*</span>
                </label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={this.handleInputChange}
                  className={`w-full h-[45px] px-[15px] border rounded-[10px] text-[14px] focus:outline-none focus:border-[#032E41] ${
                    errors.email ? 'border-red-500' : 'border-gray-200'
                  }`}
                />
                {errors.email && (
                  <p className="text-red-500 text-[12px] mt-[5px]">{errors.email}</p>
                )}
              </div>

              {/* Комментарий (необязательное) */}
              <div>
                <label className="block text-[14px] text-black/60 mb-[5px]">Комментарий</label>
                <textarea
                  name="comment"
                  value={formData.comment}
                  onChange={this.handleInputChange}
                  rows="3"
                  className="w-full px-[15px] py-[10px] border border-gray-200 rounded-[10px] text-[14px] focus:outline-none focus:border-[#032E41] resize-none"
                />
              </div>

              {/* Галочка согласия */}
              <div className="pt-[10px]">
                <label className="flex items-start gap-[10px] cursor-pointer">
                  <input
                    type="checkbox"
                    name="agreement"
                    checked={formData.agreement}
                    onChange={this.handleInputChange}
                    className="mt-[2px]"
                  />
                  <span className="text-[12px] text-black/60 leading-tight">
                    Я даю согласие на обработку моих персональных данных (фамилия, имя, телефон, адрес электронной почты) в соответствии с <a href="/policy" target="_blank" className="text-[#032E41] hover:underline">Политикой обработки персональных данных</a> и <a href="/agreement" target="_blank" className="text-[#032E41] hover:underline">Согласием на обработку персональных данных</a>.
                  </span>
                </label>
                {errors.agreement && (
                  <p className="text-red-500 text-[12px] mt-[5px]">{errors.agreement}</p>
                )}
              </div>

              {/* Кнопка отправки */}
              <div className="pt-[15px]">
                <button
                  type="submit"
                  disabled={isSending}
                  className="w-full h-[50px] bg-[#032E41] text-white rounded-full text-[16px] font-medium hover:bg-opacity-90 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  {isSending ? 'Отправка...' : 'Отправить'}
                </button>
              </div>
            </form>
          </div>
        </div>
      </>
    );
  }
}

export default OffcanvasForm;